export default __webpack_public_path__ + "static/BW-link-cover-PL-b80094b27b9fb1239ad2ff3daa085f36.jpg";